module.exports = __webpack_public_path__ + "img/mt.b6693542.svg";